"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$t = exports.intl = exports.getMessagesForLocale = exports.getUserLocale = void 0;
const intl_1 = require("@formatjs/intl");
const bg_json_1 = __importDefault(require("./compiled/bg.json"));
const de_json_1 = __importDefault(require("./compiled/de.json"));
const en_json_1 = __importDefault(require("./compiled/en.json"));
const es_json_1 = __importDefault(require("./compiled/es.json"));
const fr_json_1 = __importDefault(require("./compiled/fr.json"));
const hi_json_1 = __importDefault(require("./compiled/hi.json"));
const it_json_1 = __importDefault(require("./compiled/it.json"));
const ja_json_1 = __importDefault(require("./compiled/ja.json"));
const nl_json_1 = __importDefault(require("./compiled/nl.json"));
const pl_json_1 = __importDefault(require("./compiled/pl.json"));
const pt_json_1 = __importDefault(require("./compiled/pt.json"));
const ro_json_1 = __importDefault(require("./compiled/ro.json"));
const ru_json_1 = __importDefault(require("./compiled/ru.json"));
const sv_json_1 = __importDefault(require("./compiled/sv.json"));
const uk_json_1 = __importDefault(require("./compiled/uk.json"));
const zh_json_1 = __importDefault(require("./compiled/zh.json"));
// We have zh-hans locale, so we added zh-hans for regexp
const URL_LOCALE_CODE_REGEXP = /^\/(?<locale>(\w{2}|zh-hans))\//;
const localeMapping = {
    bg: bg_json_1.default,
    de: de_json_1.default,
    en: en_json_1.default,
    es: es_json_1.default,
    fr: fr_json_1.default,
    hi: hi_json_1.default,
    it: it_json_1.default,
    ja: ja_json_1.default,
    nl: nl_json_1.default,
    pl: pl_json_1.default,
    pt: pt_json_1.default,
    ro: ro_json_1.default,
    ru: ru_json_1.default,
    sv: sv_json_1.default,
    uk: uk_json_1.default,
    zh: zh_json_1.default,
};
const defaultLocale = "en";
const isLocale = (locale) => {
    if (!locale)
        return false;
    return locale in localeMapping;
};
const parseLocaleFromUrl = () => {
    var _a, _b;
    return (_b = (_a = URL_LOCALE_CODE_REGEXP.exec(location.pathname)) === null || _a === void 0 ? void 0 : _a.groups) === null || _b === void 0 ? void 0 : _b.locale;
};
const getUserLocale = () => {
    // Else attempt grabbing the locale from the url.
    // If nothing is found, then use 'en' as a fallback.
    let locale = parseLocaleFromUrl();
    if (locale === "zh-hans") {
        locale = "zh";
    }
    if (isLocale(locale)) {
        return locale;
    }
    return defaultLocale;
};
exports.getUserLocale = getUserLocale;
const getMessagesForLocale = (locale) => {
    var _a;
    return (_a = localeMapping[locale]) !== null && _a !== void 0 ? _a : en_json_1.default;
};
exports.getMessagesForLocale = getMessagesForLocale;
const userLocale = (0, exports.getUserLocale)();
const cache = (0, intl_1.createIntlCache)();
const messages = (0, exports.getMessagesForLocale)(userLocale);
exports.intl = (0, intl_1.createIntl)({
    locale: userLocale,
    defaultLocale,
    messages,
}, cache);
// This intentionally only exposes the formatMessage method, although intl
// provides many other methods and APIs to use. Consider using intl.<method>
// if you need to use something else, or adding another variable as an alias.
// eslint-disable-next-line @typescript-eslint/unbound-method
exports.$t = exports.intl.formatMessage;
